import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/marketing/Reveal";

export default function SectorPlacements({ placements = [], alsoAvailable = [], browseLink = "/services/guaranteed-placements", tag, title, subtitle }) {
  return (
    <section className="py-12 lg:py-16 bg-slate/30">
      <Container>
        <Reveal>
        <SectionHeading tag={tag} title={title} subtitle={subtitle} />
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-5">
          {placements.map((p, i) => (
            <Reveal key={p.name} variant="card" delay={i * 0.08}>
            <div
              className="group bg-white border border-border rounded-xl p-5 lg:p-6 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="h-14 flex items-center justify-center mb-4">
                {p.logo ? (
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="max-h-10 max-w-[140px] w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                  />
                ) : (
                  <span className="font-heading text-lg font-bold text-[#8b8fa3] group-hover:text-bone transition-colors duration-300">
                    {p.name}
                  </span>
                )}
              </div>
              <div className="flex items-center justify-between text-xs text-steel mt-auto pt-3 border-t border-border">
                <span className="font-medium">DA {p.da}</span>
                <span className="capitalize">{p.linkType}</span>
              </div>
            </div>
            </Reveal>
          ))}
        </div>
        {alsoAvailable.length > 0 && (
          <div className="mt-8 text-center">
            <p className="text-sm text-steel mb-3">Also available:</p>
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
              {alsoAvailable.map((name) => (
                <span key={name} className="text-sm font-medium text-faded hover:text-bone transition-colors">
                  {name}
                </span>
              ))}
            </div>
          </div>
        )}
        <Reveal>
        <div className="mt-10 text-center">
          <Link
            to={browseLink}
            className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors"
          >
            Browse all guaranteed placements <ArrowRight className="ml-1.5 w-4 h-4" />
          </Link>
        </div>
        </Reveal>
      </Container>
    </section>
  );
}